import React from 'react';
import * as PropTypes from 'prop-types';
import { Link } from '../../router';

import i18n from '../../translations/i18n';
import R from '../../lib/routes';
import { dateDisplay } from '../../lib/selectors';
import { classNamer, capitalizeFirstLetter } from '../../lib/utils';

const cn = classNamer('KBArticlesList');

import './KBArticlesList.scss';

const KBArticlesList = ({ articles, showCategory }) => {
  return (
    <div className={cn()}>
      {!articles.length ? (
        <p className={cn('no-articles')}>{i18n.noRecentActivity}</p>
      ) : (
        <ul>
          {articles.map(article => (
            <li key={article.id}>
              <div className={cn('header')}>
                <h2 className={cn('title')}>
                  <Link route={R.kbArticleBySlug(article)}>
                    <a>{article.title}</a>
                  </Link>
                </h2>
                {showCategory && (
                  <div className={cn('category')}>
                    {article.category && Object.keys(article.category).length > 0 ? (
                      capitalizeFirstLetter(article.category.name)
                    ) : (
                      <span className="text-danger">{i18n.uncategorized}</span>
                    )}
                  </div>
                )}
              </div>
              {article.published_at ? (
                <div className={cn('date')}>{dateDisplay(article.published_at)}</div>
              ) : (
                <div className="date text-danger">{i18n.unpublished}</div>
              )}
              <div className={cn('content')}>{article.summary}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

KBArticlesList.propTypes = {
  articles: PropTypes.array,

  showCategory: PropTypes.bool,
};

export default KBArticlesList;
